// extracted by mini-css-extract-plugin
export var compact = "_q7-2";
export var phoneFrame = "_q7-0";
export var phoneScreen = "_q7-1";